import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, isRef as _isRef, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "social-select__divider"
}

import { useVModel } from '@vueuse/core';
import VSelect from './VSelect.vue';
import FacebookIcon from '@/components/icons/other/FacebookIcon.vue';
import InstagramIcon from '@/components/icons/other/InstagramIcon.vue';
import TiktokIcon from '@/components/icons/other/TiktokIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VSocialSelect',
  props: {
    modelValue: null,
    disableInst: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue?: string | null, disableInst?: boolean }




const model = useVModel(props, 'modelValue', emit)

const socialItems = [
  { id: null, title: "All" },
  //{ id: "fb", title: props.disableInst? "Facebook": "Facebook/Instagram" },
  { id: "fb", title: "Facebook" },
  { id: "ig", title: "Instagram" },
  // { id: "tiktok", title: "TikTok" }
]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VSelect, {
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    class: "social-select",
    items: socialItems
  }, {
    default: _withCtx(() => [
      (_unref(model) === null || _unref(model) === 'fb')
        ? (_openBlock(), _createBlock(FacebookIcon, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(model) === null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      (_unref(model) === null || _unref(model) === 'ig')
        ? (_openBlock(), _createBlock(InstagramIcon, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})